import { useDispatch } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { UseMutationOptions } from "@tanstack/react-query";

import { patientKeys } from "@/features/patient/api/keyFactory";
import { waitlistStatusChanged } from "@/redux/actions/patient";

import {
  removeFromWaitList,
  type RemoveFromWaitListVariables,
} from "../queryFunctions/removeFromWaitList";

type UseRemoveFromWaitListOptions = UseMutationOptions<void, unknown, RemoveFromWaitListVariables>;

export function useRemoveFromWaitList({ onSuccess, ...options }: UseRemoveFromWaitListOptions) {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  return useMutation({
    mutationFn: removeFromWaitList,
    ...options,
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries({
        queryKey: patientKeys.details(variables.patientId),
      });

      dispatch(waitlistStatusChanged()); // signals legacy ActivityFeed to re-fetch

      // Caller-supplied callback
      onSuccess?.(data, variables, context);
    },
  });
}
